import { createFileRoute } from '@tanstack/react-router';
import LoyaltyManagement from '../../components/manager/LoyaltyManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/loyalty')({
  component: LoyaltyManagementRoute,
});

function LoyaltyManagementRoute() {
  return (
    <ManagerPortal>
      <LoyaltyManagement />
    </ManagerPortal>
  );
}
